<ng-container *transloco="let t; read: 'configuration'">
<div class="pl-5 pb-5 w-full">
  <div class="flex justify-between">
    <!-- Server-supplied permission display name. -->
    <h1 class="text-2xl font-medium">{{ permission?.displayName }}</h1>
    <mat-checkbox [(ngModel)]="stateDashboardEnabled" color="primary">
      <span class="font-bold">{{ t('stateConfiguration.dashboard.enabled') }}</span>
    </mat-checkbox>
  </div>
  @if (stateDashboardEnabled) {
    <form id="dashboardForm" class="grid grid-cols-2 gap-1 pt-4" [formGroup]="dashboardForm">
      <div class="col-span-1 items-center w-[100%]">
        <label class="font-bold" for="Name">{{ t('stateConfiguration.dashboard.tileName') }}</label>
      </div>
      <div class="col-span-1 items-center w-[100%]">
        <label class="font-bold" for="Options">{{ t('stateConfiguration.dashboard.tileStatus') }}</label>
      </div>
      @for (tile of dashboardTiles; track tile) {
        <div class="flex flex-col justify-center w-[100%]">
          <!-- Server-supplied tile title. -->
          <label class="font-normal" [for]="tile.controlName">{{ tile.title }}</label>
        </div>
        <div class="flex flex-col w-[100%] h-min mt-1.5">
          <mat-checkbox [formControlName]="tile.controlName" color="primary">{{ t('common.enable') }}</mat-checkbox>
        </div>
      }
    </form>
  }
  <div class="col-span-2 w-[100%] h-min" [class.mt-6]="!stateDashboardEnabled">
    <div class="flex justify-end w-[100%]">
      <drdp-btn color="cancel" (click)="onCancel()">{{ t('common.cancel') }}</drdp-btn>
      <span class=" ml-5"><drdp-btn (click)="onSubmit()" [disabled]="isSubmitting">{{ t('common.saveAndSubmit') }}</drdp-btn></span>
    </div>
  </div>
</div>
</ng-container>
